import { ca } from '@cian/analytics';

import { EBlockInPageName } from '../types/share';

export function trackChartTapOrHover(blockInPage: EBlockInPageName, isNotMobile: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AnalisysOnline',
    action: isNotMobile ? 'Click' : 'Hover',
    label: blockInPage,
  });
}
